import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CartProduct } from "../../../data/models/CartState/CartProduct";

type CartStateState = {
    cartProducts : Array<CartProduct>
}

const initialState : CartStateState = {
    cartProducts : []
}

type UpdateParameters = {
    name : string,
    quantity : number
}

export const cartStateSlice = createSlice({
    name: 'cartState',
    initialState: initialState,
    reducers: {
        addProductToCart: (state, action : PayloadAction<CartProduct>) => {
            const newCartProduct = action.payload;
            const currentState = state.cartProducts;
            let productInCart = false;

            // Check if we have the product in our cart already
            //  If true, add the quantity to the product in the cart
            //  Else, we add the new product to the cart
            for(let i = 0; i < currentState.length; i++) {
                if(currentState[i].product.name === newCartProduct.product.name) {
                    currentState[i].quantity = currentState[i].quantity + newCartProduct.quantity;
                    productInCart = true;
                }
            }

            if(!productInCart) {
                currentState.push(newCartProduct);
            }

            state.cartProducts = currentState;
        },
        updateProductQuantityByName: (state,  action : PayloadAction<UpdateParameters>) => {
            const parameters = action.payload;
            const newQuantity = parameters.quantity;
            const name = parameters.name;
            const currentState = state.cartProducts;

            // Find our productId in our cartProducts and set the new quantity
            for(let i = 0; i < currentState.length; i++) {
                if(currentState[i].product.name === name) {
                    currentState[i].quantity = newQuantity;
                }
            }

            state.cartProducts = currentState;
        },
        removeProductByName : (state, action : PayloadAction<string>) => {
            const currentState = state.cartProducts;
            const nameToRemove = action.payload;
            const newState = currentState.filter((element : CartProduct) => element.product.name !== nameToRemove);

            state.cartProducts = newState;
        },
        clearCartProducts: (state) => {
            state.cartProducts = [];
        },
    }
});

export const { 
    addProductToCart, 
    updateProductQuantityByName,
    removeProductByName,
    clearCartProducts } = cartStateSlice.actions;

export default cartStateSlice.reducer;
